import { render, staticRenderFns } from "./AddFactor.vue?vue&type=template&id=74d569bc&scoped=true"
import script from "./AddFactor.vue?vue&type=script&lang=js"
export * from "./AddFactor.vue?vue&type=script&lang=js"
import style0 from "./AddFactor.vue?vue&type=style&index=0&id=74d569bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d569bc",
  null
  
)

export default component.exports